import { render, staticRenderFns } from "./AreaContacts.vue?vue&type=template&id=36258f7c"
import script from "./AreaContacts.vue?vue&type=script&lang=ts"
export * from "./AreaContacts.vue?vue&type=script&lang=ts"
import style0 from "./AreaContacts.vue?vue&type=style&index=0&id=36258f7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports